export function debounce(func: (obj: any) => any, wait: number, context: any): (obj: any) => any {
  let timeout: any
  const functionContext = context
  return function (obj: any) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const context: any = functionContext
    // eslint-disable-next-line prefer-rest-params
    const args: any = arguments
    const later = function () {
      timeout = null
      func.apply(context, args)
    }

    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}
